import { IUserAudio } from 'store/types/audio'

const filterAudioBySearchValue = (items: IUserAudio[], searchValue: string) => {
  return items.filter(item =>
    item.title.toLowerCase().includes(searchValue.toLowerCase())
  )
}

const removeSimilarAudios = (audios: IUserAudio[]) => {
  return audios.reduce(
    (acc, audio) => {
      if (!acc.find(item => item.path === audio.path)) {
        acc.push(audio)
      }
      return acc
    },
    <IUserAudio[]>[]
  )
}

export const searchAudio = (
  searchValue: string,
  libSoundsInOneList: IUserAudio[],
  userSounds: IUserAudio[]
) => {
  if (!searchValue) {
    return []
  }

  const searchedGenres = filterAudioBySearchValue(
    libSoundsInOneList,
    searchValue
  )

  const searchedUserSounds = filterAudioBySearchValue(userSounds, searchValue)

  return removeSimilarAudios([...searchedGenres, ...searchedUserSounds])
}
